export default [
	{
	  name: 'Intro_Part1',
	  start: '0:00.000',
	  end: '0:33.965',
	  duration: '0:33.965'
	},
	{
	  name: 'Intro_Part2',
	  start: '0:40.000',
	  end: '1:58.124',
	  duration: '1:18.124'
	},
	{
	  name: 'Grappe1',
	  start: '2:30.000',
	  end: '2:59.092',
	  duration: '0:29.092'
	},
	{
	  name: 'Grappe2',
	  start: '3:30.000',
	  end: '4:00.157',
	  duration: '0:30.157'
	},
	{
	  name: 'Grappe3',
	  start: '4:30.000',
	  end: '5:01.121',
	  duration: '0:31.121'
	},
	{
	  name: 'Grappe4',
	  start: '5:30.000',
	  end: '6:09.480',
	  duration: '0:39.480'
	},
	{
	  name: 'Grappe5',
	  start: '6:30.000',
	  end: '6:57.490',
	  duration: '0:27.490'
	},
	{
	  name: 'Grappe6',
	  start: '7:30.000',
	  end: '8:03.553',
	  duration: '0:33.553'
	},
	{
	  name: 'Grappe7',
	  start: '8:30.000',
	  end: '9:01.312',
	  duration: '0:31.312'
	},
	{
	  name: 'Conclusion',
	  start: '10:00.000',
	  end: '11:07.962',
	  duration: '1:07.962'
	},
]



// WEBPACK FOOTER //
// ./src/components/music/music/narrations_en.js